import script from "./schoolDtails.vue?vue&type=script&setup=true&lang=js"
export * from "./schoolDtails.vue?vue&type=script&setup=true&lang=js"

import "./schoolDtails.vue?vue&type=style&index=0&id=a469a72e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a469a72e"]])

export default __exports__